__turbopack_context__.v({
  "menu": "F79zcq_menu",
  "menu-selected": "F79zcq_menu-selected",
});
